import { render, staticRenderFns } from "./UserTicketUpdateDialog.vue?vue&type=template&id=6639355a&scoped=true"
import script from "./UserTicketUpdateDialog.vue?vue&type=script&lang=js"
export * from "./UserTicketUpdateDialog.vue?vue&type=script&lang=js"
import style0 from "./UserTicketUpdateDialog.vue?vue&type=style&index=0&id=6639355a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6639355a",
  null
  
)

export default component.exports